import { render } from "./IconCheckbox.vue?vue&type=template&id=eb7500f2&scoped=true"
import script from "./IconCheckbox.vue?vue&type=script&lang=js"
export * from "./IconCheckbox.vue?vue&type=script&lang=js"

import "./IconCheckbox.vue?vue&type=style&index=0&id=eb7500f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb7500f2"]])

export default __exports__